module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    attrs: {
      "temporary": "",
      "mini-variant": _vm.miniVariant,
      "clipped": _vm.clipped,
      "value": _vm.drawer,
      "enable-resize-watcher": ""
    },
    on: {
      "input": _vm.change
    }
  }, [_c('v-list', [_c('v-list-tile', {
    nativeOn: {
      "click": function($event) {
        _vm.miniVariant = !_vm.miniVariant
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.miniVariant ? 'chevron_right' : 'chevron_left')
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Meniu ingust")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    nativeOn: {
      "click": function($event) {
        return _vm.toggleLight($event)
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "app-light"
  }, [_vm._v(_vm._s(!_vm.light ? 'lightbulb_outline' : 'wb_incandescent'))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Lumina")])], 1)], 1), _vm._v(" "), _vm._l((_vm.items), function(item, i) {
    return (_vm.displayLinkToRoute(item)) ? _c('v-list-tile', {
      key: i,
      attrs: {
        "to": item.link
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.title)
      }
    })], 1)], 1) : _vm._e()
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72dad2e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Drawer.vue
// module id = 603
// module chunks = 12